import ActionTypes from './actionTypes/index';
import { getComponentConfig, postComponentAction } from '../api/componentConfigApi';
import { objectToQueryString } from '../utils/misc';

const {
    COMPONENT_CONFIG_FETCH_REQUEST,
    COMPONENT_CONFIG_FETCH_SUCCESS,
    COMPONENT_CONFIG_FETCH_FAILURE,
    COMPONENT_CONFIG_RESET,
    COMPONENT_CONFIG_ACTION_PERFORMED,
    COMPONENT_CONFIG_ACTION_PERFORMED_SUCCESS,
    COMPONENT_CONFIG_ACTION_PERFORMED_FAILURE,
} = ActionTypes;

export const fetchComponentConfig = (componentName, params) => (dispatch, getState, { mainApi }) => {
    const { auth } = getState();
    const userLoggedIn = auth && auth.user;

    dispatch(resetComponentConfig(componentName));

    if (userLoggedIn) {
        dispatch({ type: COMPONENT_CONFIG_FETCH_REQUEST });
        getComponentConfig(mainApi, {
            componentName,
            paramString: params ? objectToQueryString(params) : '',
        })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: COMPONENT_CONFIG_FETCH_FAILURE });
                } else {
                    console.log(COMPONENT_CONFIG_FETCH_SUCCESS);
                    dispatch({
                        type: COMPONENT_CONFIG_FETCH_SUCCESS,
                        data: {
                            component: componentName,
                            config: data,
                        },
                    });
                }
            })
            .catch(() => {
                dispatch({
                    type: COMPONENT_CONFIG_FETCH_FAILURE,
                });
            });
    }
};

export const resetComponentConfig = (componentName) => (dispatch) => {
    dispatch({
        type: COMPONENT_CONFIG_RESET,
        data: {
            component: componentName,
        },
    });
};

export const postComponentActionPerformd = (componentName, configType, actionName, data) => (dispatch, getState, { mainApi }) => {
    dispatch({ type: COMPONENT_CONFIG_ACTION_PERFORMED });
    postComponentAction(mainApi, componentName, actionName, data)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: COMPONENT_CONFIG_ACTION_PERFORMED_FAILURE });
            } else {
                console.log(COMPONENT_CONFIG_ACTION_PERFORMED_SUCCESS);
                dispatch({
                    type: COMPONENT_CONFIG_ACTION_PERFORMED_SUCCESS,
                    data: {
                        componentName,
                        configType,
                    },
                });
            }
        })
        .catch(() => {
            dispatch({
                type: COMPONENT_CONFIG_ACTION_PERFORMED_FAILURE,
            });
        });
};
